// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","black":"#000","copyColor":"#333","primary":"#336b9b","primaryHover":"#184368","primaryActive":"#184368"};